// Campaign action link — financing trust warm-up → Cherry apply.
//
// Hosted at /action/apply-financing/:token. The signed ca1 token in the URL
// IS the credential — no login. See
// docs/superpowers/specs/2026-07-16-campaign-action-links-design.md and
// server/routes/campaign-action-routes.ts.
//
// Wrapper + lazy + shell pattern (mirrors
// client/src/pages/patient-portal/sign_envelope.tsx): the shell below is
// module-level and import-cheap so index.tsx can eager-import it (for
// PublicCatchAllDispatcher) without dragging the heavy content chunk along.
// CampaignFinancingContent renders only inside the <Suspense> below.

import { lazy, Suspense } from "react";
import { Spin } from "antd";

const CampaignFinancingContent = lazy(
  () => import("./CampaignFinancingContent"),
);

// Full-viewport loader so the patient never sees a flash of the quote-funnel
// landing page while the token/info fetch is in flight. Exported so the /*
// catch-all dispatcher in index.tsx can reuse the same loading state when it
// intercepts /action/apply-financing/* URLs at the splat level. See
// docs/infrastructure/PATIENT_FACING_EMAIL_LINKS.md.
export const CampaignFinancingLoadingShell = () => (
  <div
    style={{
      minHeight: "100vh",
      backgroundColor: "#f5f5f5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      gap: 16,
    }}
  >
    <Spin size="large" />
    <div style={{ color: "#666", fontSize: 14 }}>Loading… · Cargando…</div>
  </div>
);

type Props = {
  // When the /* catch-all wins over the explicit
  // /action/apply-financing/:token route, useParams() never binds :token —
  // the dispatcher passes the captured segment here instead. Mirrors
  // BookingPage's tokenOverride.
  tokenOverride?: string;
};

const CampaignFinancingPage: React.FC<Props> = ({ tokenOverride }) => (
  <Suspense fallback={<CampaignFinancingLoadingShell />}>
    <CampaignFinancingContent tokenOverride={tokenOverride} />
  </Suspense>
);

export default CampaignFinancingPage;
